import { PanelDesignTokens } from '@primeuix/themes/types/panel';

export const Panel: PanelDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
  },
  content: {
    padding: '0 1.25rem 1.25rem',
  },
  colorScheme: {
    light: {
      root: {
        background: '{surface.0}',
        borderColor: '{surface.300}',
      },
    },
  },
  css: () => `
    .p-panel-title {
      font-size: 1.5rem;
    }


    .p-panel {
      display: flex;
      flex-direction: column;

      .p-panel-header {
        flex-shrink: 0;
        .panel-header {
          display: flex;
          width: 100%;
          align-items: center;
          gap: 1rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid var(--p-surface-300);

          h3{
            font-size: 1.25rem;
          }
          h1,h2,h3,h4,h5,h6 {
            margin: .325rem 0 ;
          }

         .actions{
          margin-left: auto;
          display: flex;
          gap: 1rem;
         }
        }

      }

      .p-panel-content-container {
        flex: 1;
        min-height: 0;
        .p-panel-content {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
      }
}
  `,
};
